import React from 'react';
import { observer } from 'mobx-react';
import MigrationDialog from './MigrationDialog';
import MigrateService from '../../services/MigrateService';

class MigrationDialogContainer extends React.Component {
  componentDidMount() {
    MigrateService.init();
  }

  render() {
    return (
      <MigrationDialog
        isOpen={MigrateService.isOpen}
        isMigrating={MigrateService.isMigrating}
        isComplete={MigrateService.isComplete}
        progress={MigrateService.progress}
        onClose={MigrateService.handleClose}
        onStart={MigrateService.startMigrate}
      />
    );
  }
}

export default observer(MigrationDialogContainer);
